import React from 'react';
import { FiX, FiShare2, FiLink2 } from 'react-icons/fi';

const FiXComponent = FiX as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const FiShare2Component = FiShare2 as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const FiLink2Component = FiLink2 as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  integrationName: string;
  logo?: string;
  loading?: boolean;
}

export const IntegrateModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  integrationName,
  logo,
  loading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50'>
      <div className='bg-white rounded-xl shadow-lg w-[550px] p-6 relative'>
        <button
          onClick={onClose}
          disabled={loading}
          className='absolute top-4 right-4 text-gray-500 hover:text-gray-700 disabled:opacity-50'
        >
          <FiXComponent size={20} />
        </button>

        <h2 className='text-[20px] font-semibold text-[#3F5265] mb-3'>
          Link Your {integrationName} Account
        </h2>

        {/* Icons Row */}
        <div className='flex items-center gap-3 mb-6'>
          <div className='p-2 bg-red-50 rounded-full'>
            <FiShare2Component size={20} className='text-[#FF5722]' />
          </div>
          <FiLink2Component size={20} className='text-green-500' />
          <div className='p-2 bg-blue-50 rounded-full'>
            <img src={logo} alt={integrationName} className='h-6 w-6' />
          </div>
        </div>

        <div className='bg-[#F5F8FA] text-[#657584] p-4 rounded-lg text-[16px] space-y-2 mb-6'>
          <p>
            1. Log in to your {integrationName} account and allow access to
            connect your data.
          </p>
          <p>2. Choose how you'd like your data to sync with our system.</p>
          <p>
            3. That's it! We'll start importing your {integrationName} data
            automatically.
          </p>
        </div>

        <div className='flex justify-end gap-3'>
          <button
            onClick={onClose}
            disabled={loading}
            className='px-4 py-2 border rounded-md text-[#3F5265] font-medium hover:bg-gray-100 disabled:opacity-50'
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className='px-4 py-2 bg-[#FF5722] text-white rounded-md font-medium hover:bg-[#e04a1c] disabled:opacity-50 disabled:cursor-not-allowed'
          >
            {loading ? 'Integrating...' : 'Integrate'}
          </button>
        </div>
      </div>
    </div>
  );
};